<template>
	<el-container>
		<el-header>
			<!-- <img style="margin-top: 12px;max-width: 40px; float: left;" @click="tomain()" :src='"/img/webimg/back.png"' alt=""> -->
			<el-button style="margin-top: 4px;font-size: 28px; float: left;color:#000000;" @click="tomain()" icon="el-icon-arrow-left" type="text"></el-button>
			<span class="header_h2">在线预约 </span>
		</el-header>
		<el-main>
		<el-row type="flex" justify="center">
			<!-- <el-tabs  v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="未约信息" name="tab1"> -->
			<div :style="{width:$myglobal.screenwidth+'px'}">
				<div v-if="nocheck">未查询到可约信息！</div>
				<div v-if="clientcheck">
					<!-- <h2 class="header_h2">单位职工预约体检</h2>
						<br> -->
					<el-row>
						<el-col :span="24" v-for="cus in cusorderlist">
							<!-- <div > -->
								<el-row class="myrow" style="margin-top: 5px;margin-bottom: 2px;">
									<el-col :span="3">
										<img v-if="cus.cussex=='1'" style="margin-top: 10px;max-width:50px ; width:auto ;height: auto;"  :src='"/img/webimg/male.png"' alt="">
										<img v-if="cus.cussex=='2'" style="margin-top: 10px;max-width:50px ; width:auto ;height: auto;" :src='"/img/webimg/female.png"'
										 alt="">

									</el-col>
									<el-col :span="15">
										<p class="myrowp">{{cus.cusname}}</p>
										<p class="myrowp" style="font-size: 10px;">{{cus.ordername}}</p>

									</el-col>
									<el-col :span="6">
										<div>
											<el-button type="primary" size="mini" round @click="toBookForOrder(cus)">去预约</el-button>
											<el-button v-if="cus.cusstatus=='25'" type="danger" size="mini" round @click="toRefundForOrder(cus)">申请退款</el-button>
										</div>
									</el-col>
								</el-row>
							<!-- </div> -->

						</el-col>
					</el-row>
				</div>
				<div v-if="cuscheck">

					<el-row>
						<el-col :span="24" v-for="cus in cuslist">
							<div>
								<el-row class="myrow" style="margin-top: 5px;margin-bottom: 2px;">
									<el-col :span="3">
										<img style="max-width:50px ; width:auto ;height: auto;margin-top: 10px;" :src='"/img/webimg/nosex.png"' alt="">

									</el-col>
									<el-col :span="15">
										<p class="myrowp">自购套餐</p>
										<p class="myrowp" style="font-size: 10px;">{{cus.cusname}}</p>
									</el-col>
									<el-col :span="6">
										<el-button type="success" size="mini" round @click="toBookForSingle(cus)">去预约</el-button>
									</el-col>
								</el-row>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</el-row>
		</el-main>
		<!-- 	</el-tab-pane>

			<el-tab-pane label="可改约信息" name="tab2">
				<bookedvue v-if="showtab2" :inmobile="mobile"></bookedvue>
			</el-tab-pane>
		</el-tabs> -->
	</el-container>
</template>

<script>
	import order from '../../apifunction/Order.js'
	import cusinfo from '../../apifunction/OrderCus.js'
	// import bookedvue from './BookedCusList.vue'
	import pay from '../../apifunction/OnlinePay.js';
	export default {
		data() {
			return {
				mobile: '',
				curcorpid: '',
				nocheck:false,
				clientcheck: false,
				cuscheck: false,
				cusorderlist: [],
				cuslist: [],
				// checkno: '',
				// activeName: 'tab1',
				// showtab1: true,
				// showtab2: false
			};
		},
		// components: {
		// 	bookedvue
		// },
		created() {
			this.mobile = this.$route.query.mobile;
			this.loadbookcus();

		},
		methods: {
			loadbookcus() {
				this.clientcheck = false,
					this.cuscheck = false,
					cusinfo.GetCusForWaitBook(this.mobile)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data == 'null') {
								this.nocheck=true;
								// let cus = this.getcusinfo();
								// cusinfo.AddCus(cus)
								// 	.then(res => {
								// 		let ent = JSON.parse(JSON.stringify(res.data))
								// 		if (ent.Flag == 'success') {
								// 			this.cuscheck = true;
								// 			this.cuslist.push(cus);
								// 		}
								// 	});

							} else {
								let templist = JSON.parse(ent.Data);
								for (let i = 0; i < templist.length; i++) {
									// templist[i].ordername = ''
									if (templist[i].orderid != '') {
										//alert(JSON.stringify(templist[i]));
										this.cusorderlist.push(templist[i]);
										//templist[i].ordername = this.getordername(templist[i].orderid);

										this.clientcheck = true;

									} else {
										this.cuscheck = true;
										this.cuslist.push(templist[i]);
									}
								}
								// if(templist.length==1)
								// {
								// 	this.toBookForOrder(templist[0]);
								// }

							}


						} else
							this.$message.info(ent.Msg);
					})
			},
			getcusinfo() {
				return {
					id: this.CommonFun.NewGuid(),
					cusname: '',
					cussex: '1',
					cusbirthday: '',
					cusmarry: '0',
					mobile: this.mobile,
					idcard: '',
					cusstatus: '11',
					memo: '',
					orderid: '',
					groupid: '',
					bookcode: '',
					corpid: '',
					ordername: ''
				};
			},
			toRefundForOrder(cus) {
				this.$confirm('确定要‘申请退款’吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					cusinfo.RefundOrderCusPay(cus.id)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								cusinfo.GetCusOrderPayByCusID(cusid, '2') //申请退款
									.then(res1 => {
										let ent1 = JSON.parse(JSON.stringify(res1.data))
										if (ent1.Flag == 'success') {
											cus.cusstatus = '10';
											let list = JSON.parse(ent1.Data);
											for (let i = 0; i < list.length; i++) {
												this.ToRefundAli(list[i]);
											}

										} else
											this.$message.info(ent1.Msg);
									})
							} else
								this.$message.info(ent.Msg);
						});
				});
			},
			ToRefundAli(row) {
				pay.RefundByAli(row.ordid, row.order_price, true, '')
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							cusinfo.RefundOrderCusPaySuccess(row.ordid)
							this.$message.info('退款成功！');
						} else
							this.$message.info(ent.Msg);
					})
			},
			toBookForOrder(cus) {
				if (cus.cusstatus == '25') //已付费
				{
					var data = {
						path: '/SelBookBranch',
						query: {
							ent: JSON.stringify(cus)
						}
					}
					this.$router.push(data)
				} else {
					var data = {
						path: '/BookForOrderCus',
						query: {
							ent: JSON.stringify(cus)
						}
					}
					this.$router.push(data)
				}

			},
			toBookForSingle(cus) {
				var data = {
					path: '/BookForSingle',
					query: {
						ent: JSON.stringify(cus)
					}
				}
				this.$router.push(data)
			},
			// handleClick() {
			// 	if (this.activeName == "tab1") {
			// 		this.showtab1 = true;
			// 		this.showtab2 = false;
			// 	} else {
			// 		this.showtab1 = false;
			// 		this.showtab2 = true;
			// 	}
			// }
			tomain() {
				this.showmenu=true;
				var data = {
					path: '/mainbook',
					query: {
						mobile: this.mobile,
						showmenu:true
					}
				
				}
				this.$router.push(data)
			},
		}
	}
</script>

<style>
</style>
